export const enum SupportChatCodeSendStatus {
    Sent = 0,
    Failed = 1,
    RateLimited = 2
}
